module.exports = __webpack_public_path__ + "img/pr-7.9f88cd82.png";